import React, { Fragment, useState, useEffect } from "react";
import { Icon } from "@cdk-uip/react-icon";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { pdf } from "@react-pdf/renderer";
import ToolkitProvider, {
  Search,
  CSVExport
} from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import api from "../../api/EmployeeExit.resource";
import { sortByDate, getFormattedDate } from "../../util/helpers";
import { PDFTemplate } from "./PDFTemplate";
import { getDeclarationPlace } from "../../util/onBoardingDataFilters";

export const EmployeeList = ({ history }) => {
  const [exitEmployeeList, setExitEmployeeList] = useState(null);
  const [showSpinner, setShowSpinner] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    getExitEmployeeList();
  }, []);
  const { SearchBar } = Search;
  const { ExportCSVButton } = CSVExport;
  const columns = [
    {
      text: "S.No.",
      hidden: true,
      csvFormatter: (cell, row, rowIndex) => rowIndex + 1
    },
    {
      dataField: "cdkEmployeeId",
      text: "Employee Id",
      headerStyle: { width: "15%" },
      sort: "true"
    },
    {
      dataField: "cdkEmployeeName",
      text: "Name",
      headerStyle: { width: "25%" },
      sort: "true",
      csvText: "Employee's Name"
    },
    {
      dataField: "employeePlace",
      text: "Place",
      headerStyle: { width: "15%" },
      sort: "true"
    },

    {
      dataField: "employeeDateOfLeaving",
      text: "Date of Leaving",
      headerStyle: { width: "15%" },
      sort: "true",
      sortFunc: (a, b, order) => sortByDate(a, b, order)
    },
    {
      dataField: "submitedDate",
      text: "Submitted Date",
      headerStyle: { width: "15%" },
      sort: "true",
      sortFunc: (a, b, order) => sortByDate(a, b, order)
    },
    {
      dataField: "",
      text: "Actions",
      headerStyle: { width: "10%" },
      csvExport: false,
      formatter: (cellContent, row) => {
        return (
          <Fragment>
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 200 }}
              overlay={renderTooltip("View Pdf")}
            >
              <Icon
                className="on-hover"
                onClick={() => handleOnClickViewEmployee(row)}
              >
                visibility
              </Icon>
            </OverlayTrigger>
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 200 }}
              overlay={renderTooltip("Download Documents")}
            >
              <Icon className="on-hover" onClick={() => getPDF(row)}>
                file_download
              </Icon>
            </OverlayTrigger>
          </Fragment>
        );
      }
    }
  ];

  const sizePerPageList = [
    {
      text: "5",
      value: 5
    },
    {
      text: "10",
      value: 10
    },
    {
      text: "20",
      value: 20
    },
    {
      text: "50",
      value: 50
    },
    {
      text: "100",
      value: 100
    }
  ];
  const defaultSorted = [
    {
      dataField: "submitedDate",
      order: "des"
    }
  ];
  const findEmployee = id => exitEmployeeList.find(emp => emp.id === id);
  const handleOnClickViewEmployee = employee => {
    const employeeDetails = findEmployee(employee.id);
    history.push({
      pathname: "/ExitPDF",
      state: {
        employeeDetails
      }
    });
  };

  const generatePDFsandZIP = async () => {
    const zip = new JSZip();
    exitEmployeeList.forEach(employee => {
      zip.file(
        `Leave Encashment_${employee.cdkEmployeeId}_${employee.cdkEmployeeName}.pdf`,
        pdf(
          <PDFTemplate
            employeeDetails={employee}
            pdfType="Leave Encashment"
            showBoth={false}
          />
        ).toBlob()
      );
      zip.file(
        `Gratuity Declaration_${employee.cdkEmployeeId}_${employee.cdkEmployeeName}.pdf`,
        pdf(
          <PDFTemplate
            employeeDetails={employee}
            pdfType="Gratuity Declaration"
            showBoth={false}
          />
        ).toBlob()
      );
    });
    return zip.generateAsync({ type: "blob" }).then(blob => {
      saveAs(blob, "ExitEmployeeList.zip");
    });
  };

  const getPDF = async employee => {
    const zip = new JSZip();
    zip.file(
      `Leave Encashment_${employee.cdkEmployeeId}_${employee.cdkEmployeeName}.pdf`,
      pdf(
        <PDFTemplate
          employeeDetails={findEmployee(employee.id)}
          pdfType="Leave Encashment"
          showBoth={false}
        />
      ).toBlob()
    );
    zip.file(
      `Gratuity Declaration_${employee.cdkEmployeeId}_${employee.cdkEmployeeName}.pdf`,
      pdf(
        <PDFTemplate
          employeeDetails={findEmployee(employee.id)}
          pdfType="Gratuity Declaration"
          showBoth={false}
        />
      ).toBlob()
    );
    return zip.generateAsync({ type: "blob" }).then(blob => {
      saveAs(blob, `${employee.cdkEmployeeId}_${employee.cdkEmployeeName}.zip`);
    });
  };
  const handleOnClickBulkDownload = async () => {
    setShowSpinner(true);
    await generatePDFsandZIP();
    setShowSpinner(false);
  };
  const getExitEmployeeList = async () => {
    setLoading(true);
    const data = await api.getEmployeeList();
    setLoading(false);
    setExitEmployeeList(data);
  };
  const getUserData = () => {
    return exitEmployeeList && exitEmployeeList.length
      ? exitEmployeeList.map(row => ({
          ...row,
          employeeDateOfLeaving: getFormattedDate(row.employeeDateOfLeaving),
          submitedDate: getFormattedDate(row.submitedDate),
          employeePlace: getDeclarationPlace(row.employeePlace)
        }))
      : [];
  };

  const renderTooltip = message => {
    return <Tooltip id={message}>{message}</Tooltip>;
  };
  return (
    <div className="mt-3 mr-3">
      <div className="text-left">
        <h5> Employee Information</h5>
      </div>
      <ToolkitProvider
        keyField="id"
        data={getUserData()}
        columns={columns}
        search
        exportCSV={{ fileName: "Candidates.csv" }}
      >
        {props => (
          <Fragment>
            <div className="candidates-search-bar">
              <Button
                onClick={handleOnClickBulkDownload}
                variant="outline-secondary"
                className="mr-3 mb-2 "
                disabled={
                  (exitEmployeeList && !exitEmployeeList.length) || showSpinner
                }
              >
                {showSpinner ? "DOWNLOADING..." : "DOWNLOAD all PDFs"}
              </Button>
              <SearchBar {...props.searchProps} />
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 200 }}
                overlay={renderTooltip("Export to CSV")}
              >
                <ExportCSVButton {...props.csvProps}>
                  <Icon>file_download</Icon>
                </ExportCSVButton>
              </OverlayTrigger>
            </div>
            <BootstrapTable
              {...props.baseProps}
              striped
              condensed
              bootstrap4
              pagination={paginationFactory({
                sizePerPage: 20,
                sizePerPageList: sizePerPageList
              })}
              defaultSorted={defaultSorted}
              noDataIndication={
                loading ? "Loading....." : "No employees are available."
              }
            />
          </Fragment>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default EmployeeList;
